import { render, staticRenderFns } from "./ViewSubscriptionplan.vue?vue&type=template&id=e96336fe&scoped=true&"
import script from "./ViewSubscriptionplan.vue?vue&type=script&lang=js&"
export * from "./ViewSubscriptionplan.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubscriptionplan.vue?vue&type=style&index=0&id=e96336fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96336fe",
  null
  
)

export default component.exports